import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFormLibraryAdd = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const addFormToLibrary = async ({ data }) => {
    setIsLoading(true);
    setResponse(null); // Reset before request
    setError(null);    // Reset before request
    try {
      const res = await axiosInstance.post(`${BASE_URL}v1/form-library/`, data);
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setResponse(null);
    setError(null);
    setIsLoading(false);
  };

  return { response, error, isLoading, addFormToLibrary, reset };
};

export default useFormLibraryAdd; 